import React, { useEffect, useState } from "react";
import {
  Center,
  Header3,
  HeadingContainer,
  CardWrapper,
  ContentContainer,
  BackArrow,
} from "../../../styles/component/style";
import { SignupContainer } from "./styles";
import { Header } from "../../internal/Header/Header";
import { Formik } from "formik";
import { ChangePasswordSchema } from "../../../helpers/validationSchema";
import { navigate, useLocation } from "@reach/router";
import FormField from "../../common/FormField/FormField";
import { PrimaryCTAButton } from "../../common/Buttons";
import useLoader from "../../../hooks/useLoader";
import AuthService from "../../../services/AuthService";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import useUser from "../../../hooks/useUser";

const Index = () => {
  const { setLoader } = useLoader();
  const { password, setPassword, setToken } = useUser();
  const { enqueueSnackbar } = useSnackbar();
  const history = useLocation();

  const [inputs] = useState([
    {
      name: "oldPassword",
      label: "Current Password",
      type: "password",
      required: true,
    },
    {
      name: "newPassword",
      label: "New Password",
      type: "password",
      required: true,
    },
    {
      name: "confirmPassword",
      label: "Confirm New Password",
      type: "password",
      required: true,
    },
  ]);

  useEffect(() => {
    if (password) {
      window.history.pushState(null, null, window.location.href);
      // window.onpopstate = function (event) {
      //   history.go(1);
      // };
    }
  }, [history]); // eslint-disable-line react-hooks/exhaustive-deps

  async function onFormSubmit({ oldPassword, newPassword }) {
    try {
      setLoader({ state: true, message: "Submitting..." });
      const payload = {
        oldPassword,
        newPassword,
      };
      const response = await AuthService.changePassword(payload);
      if (response) {
        enqueueSnackbar(response.message, {
          variant: "success",
        });
        setToken(response?.token);
        setPassword(null);
        navigate("/dashboard");
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  return (
    <Header hideIcon={true}>
      <Center>
        <SignupContainer>
          <Formik
            initialValues={{
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            }}
            enableReinitialize
            onSubmit={onFormSubmit}
            validationSchema={ChangePasswordSchema}
            validateOnBlur
            validateOnChange
          >
            {({
              values,
              handleChange,
              errors,
              handleSubmit,
              touched,
              handleBlur,
              setFieldValue,
              isValid,
            }) => (
              <CardWrapper onSubmit={handleSubmit}>
                <HeadingContainer>
                  {password ? null : (
                    <BackArrow
                      onClick={() => navigate("/")}
                      src={require("../../../assets/images/backArrow.svg")}
                    />
                  )}
                  <Header3>CHANGE PASSWORD</Header3>
                </HeadingContainer>
                <ContentContainer style={{ marginTop: 34 }}>
                  {inputs.map((input, index) => {
                    return (
                      <FormField
                        key={index}
                        {...{
                          touched,
                          errors,
                          input,
                          values,
                          handleChange,
                          handleBlur,
                          setFieldValue,
                        }}
                      />
                    );
                  })}
                </ContentContainer>

                <div className="pt20 pb10">
                  <PrimaryCTAButton
                    type="submit"
                    onClick={handleSubmit}
                    disabled={!isValid}
                  >
                    Change Password
                  </PrimaryCTAButton>
                </div>
              </CardWrapper>
            )}
          </Formik>
        </SignupContainer>
      </Center>
    </Header>
  );
};

export default Index;
